const columns = [
  {
    title: '站房编号',
    dataIndex: 'stationCode',
    key: 'stationCode'
  },
  {
    title: '站房名称',
    dataIndex: 'stationName',
    key: 'stationName',
    scopedSlots: { customRender: 'stationName' }
  },
  {
    title: '客户名称',
    dataIndex: 'companyName',
    key: 'companyName'
  },
  {
    title: '备注',
    dataIndex: 'remark',
    key: 'remark'
  },
  {
    title: '创建日期',
    dataIndex: 'createdAt',
    key: 'createdAt',
    scopedSlots: { customRender: 'createdAt' }
  },
  {
    title: '更新日期',
    dataIndex: 'updatedAt',
    key: 'updatedAt',
    scopedSlots: { customRender: 'updatedAt' }
  },
  {
    title: '操作',
    key: 'operation',
    scopedSlots: { customRender: 'operation' }
  }
]

const deviceColumns = [
  {
    title: '设备编号',
    dataIndex: 'deviceCode',
    key: 'deviceCode'
  },
  {
    title: '设备名称',
    dataIndex: 'deviceName',
    key: 'deviceName'
  },
  {
    title: '规格型号',
    dataIndex: 'model',
    key: 'model'
  },
  {
    title: '品牌',
    dataIndex: 'brand',
    key: 'brand'
  },
  {
    title: '安装位置',
    dataIndex: 'address',
    key: 'address'
  },
  {
    title: '驱动类型',
    dataIndex: 'driverType',
    key: 'driverType'
  },
  {
    title: '协议编号',
    dataIndex: 'protocolCode',
    key: 'protocolCode'
  },
  {
    title: '模块编号',
    dataIndex: 'dtuCode',
    key: 'dtuCode'
  },
  {
    title: '备注',
    dataIndex: 'remark',
    key: 'remark'
  }
]

export {
  columns,
  deviceColumns
}
